export default __webpack_public_path__ + "static/media/large_tree_pls.2c8fb256.png";